import { Component, OnInit } from '@angular/core';
import { GraphyService } from '../graphy.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-graphy-enrollment-list',
  templateUrl: './graphy-enrollment-list.component.html',
  styleUrls: ['./graphy-enrollment-list.component.scss']
})
export class GraphyEnrollmentListComponent implements OnInit {
  enrollments: any[] = [];
  enrollment_status=[
    {name:'Classroom' , _id:'classroom'},
    {name:'Completed' , _id:'completed'}
  ]
  loading = true;
  columns = [
    { prop: 'learner.name', name: 'Learner Name' },
    { prop: 'learner.email', name: 'Email' },
    { prop: 'learner.mobile', name: 'Mobile' },
    { prop: 'courseName', name: 'Course' },
    { prop: 'courseLink', name: 'Course Link' },
    { prop: 'assignedThrough', name: 'Assigned Through' },
    { prop: 'courseValidity', name: 'Validity' },
    { prop: 'status', name: 'Status' }
  ];
  activeTab='classroom';

  constructor(private graphyService: GraphyService,
    private activatedRoute: ActivatedRoute,
    private route:Router
  ) {
    this.activatedRoute.queryParams
    .subscribe((params: any) => {
      if(params?.status) this.activeTab = params?.status;
      this.getEnrollments(this.activeTab)
    })
  }
 // =========================================== change enrollement tabs =========================================================
 activeEnrollmentTab(tab_id) {
    const activetab = tab_id;
    if (activetab !== '') {
      this.route.navigate(
        [],
        { relativeTo: this.activatedRoute, queryParams: { status: activetab },queryParamsHandling: 'merge' }
      );
    } 
}
  ngOnInit(): void {

  }
  getEnrollments(status){
    this
    this.graphyService.getEnrollments(status).subscribe({
      next: (res) => {
        console.log(res);
        this.enrollments = res.data || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }
} 